import script from "./NavigationBars.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationBars.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationBars.vue?vue&type=style&index=0&id=554a0ba4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554a0ba4"]])

export default __exports__